<template>
  <div>
    <carousel class="carousel"
            :scroll-per-page="true"
              :autoplay="true"
              :autoplay-timeout="3500"
            :per-page="1">
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/01.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/02.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/03.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/04.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/05.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/06.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/07.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/08.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/09.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/10.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/11.jpg"
                alt=""
                class="slides">
      </slide>     
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/12.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/13.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/14.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/15.jpg"
                alt=""
                class="slides">
      </slide>
      <slide >
        <img
                src="https://wernicke-foto.de/bilder/home/16.jpg"
                alt=""
                class="slides">
      </slide>
    
    </carousel>
  </div>
</template>

<script>
  export default {
    name: "Homepage"
  }
</script>

<style scoped>
  .slides {
    width: 100%;
  }
</style>